import React from 'react';
import PropTypes from 'prop-types';
import { WrappedFileUpload } from './WrappedFileUpload.component';

// eslint-disable-next-line react/display-name
export const WrappedDragAndDropFileUpload = ({
	className = '',
	dataqa,
	disabled = false,
	dropAreaText = 'Drag and drop a file',
	onSelect,
	supportedFormats,
	onUploadComplete = false,
	isUploading,
	importedFileName,
}) => {
	const preventDefaults = e => {
		e.preventDefault();
	};

	const fileDrop = e => {
		e.preventDefault();
		const { files } = e.dataTransfer;

		if (!disabled && onSelect) {
			onSelect({ files });
		}
	};

	const renderUploadIcon = () => (
		<div className="icon-container">
			<i className="upload-icon" />
		</div>
	);

	return (
		<div
			className={`common-ui-drag-and-drop-file-upload ${className} ${
				disabled ? 'p-disabled' : ''
			}`}
			data-qa={`ui-fileupload-${dataqa}`}
			{...{ dataqa: `ui-fileupload-${dataqa}` }}
		>
			{!onUploadComplete ? (
				<div
					className="drop-container"
					onDragOver={preventDefaults}
					onDragEnter={preventDefaults}
					onDragLeave={preventDefaults}
					onDrop={fileDrop}
				>
					<div className="drop-area-background">
						{renderUploadIcon()}
						<br />
						<p className="drop-area-text">{dropAreaText}</p>
					</div>
					<p className="text-secondary">or</p>
					<WrappedFileUpload
						name="importContactsUpload"
						className="import-contacts-upload-button"
						dataqa="importcontactsupload"
						chooseLabel="Browse"
						accept=".csv"
						auto
						customUpload
						onSelect={onSelect}
						emptyTemplate={
							<p className="p-m-0">Drag and drop files to here to upload.</p>
						}
					/>
					<p className="text-secondary supported-formats">
						{supportedFormats && `Supported formats: ${supportedFormats}`}
					</p>
				</div>
			) : (
				<div className="successful-upload">
					{isUploading ? renderUploadIcon() : <div className="success-icon" />}
					<br />
					<div className="success-message">
						{isUploading ? 'Uploading ' : ''}
						{importedFileName}
						{isUploading ? '...' : ' uploaded!'}
					</div>
				</div>
			)}
		</div>
	);
};

WrappedDragAndDropFileUpload.propTypes = {
	// Text shown in the drop area.
	dropAreaText: PropTypes.string,

	// Style class of the component.
	className: PropTypes.string,

	// When disabled is true, the drop file is restricted
	disabled: PropTypes.bool,

	// Event: Callback to invoke when file upload is complete.
	onSelect: PropTypes.func,

	// For QA automation testing.
	dataqa: PropTypes.string,

	// Text shown below the upload button, listing the supported formats for the file upload.
	supportedFormats: PropTypes.string,
};
